import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [openSection, setOpenSection] = useState(null);
  const [openQuestion, setOpenQuestion] = useState(null);

  // ✅ Refs pour les animations au scroll
  const pageRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // ✅ Observer pour les animations au scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (pageRef.current) {
      observer.observe(pageRef.current);
    }

    return () => {
      if (pageRef.current) {
        observer.unobserve(pageRef.current);
      }
    };
  }, []);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  // Icônes SVG
  const Icons = {
    ChevronDown: () => (
      <svg className="w-5 h-5 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    ),
    ChevronRight: () => (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    ),
    Map: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
      </svg>
    ),
    Clock: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    Package: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    Door: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
    CreditCard: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    ),
    Support: () => (
      <svg className="w-12 h-12 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 5.636L16.95 7.05m4.95 1.95l-1.414 1.414M21 12a9 9 0 11-18 0 9 9 0 0118 0zM12 8v4l3 3" />
      </svg>
    )
  };

  const faqSections = [
    {
      id: 'delivery',
      title: 'Livraison packs eau, sodas et lait ',
      icon: <Icons.Map />,
      questions: [
        { q: 'Livrez-vous dans ma commune ?', a: 'Entrez votre code postal sur la page d\'accueil pour vérifier l\'éligibilité.' },
        { q: 'Dans quelle zone livrez-vous ?', a: 'Les zones ont vocation à s\'élargir progressivement , Entrez votre code postal sur la page d\'accueil pour vérifier l\'éligibilité.' },
        { q: 'Que se passe-t-il si mon code postal est hors zone ?', a: 'Si votre code postal est hors zone, vous ne pourrez pas valider votre commande. Remplissez le formulaire qui s\'affiche apres inéligibilité pour être informé des nouvelles zones de livraison.' },
        { q: 'Puis-je commander si je suis en dehors de la zone de livraison ?', a: 'Pour le moment, non. Nous travaillons à étendre notre zone de livraison. Laissez-nous vos coordonnées, nous vous contacterons dès que possible.' }
      ]
    },
    {
      id: 'slots',
      title: 'Créneaux de livraison',
      icon: <Icons.Clock />,
      questions: [
        { q: 'Quels créneaux de livraison sont disponibles ?', a: 'Deux créneaux sont disponibles : Lundi au Vendredi (18h-22h), Samedi et Dimanche (08h-22h) ou Flexible (toute la journée).' },
        { q: 'Puis-je choisir mon créneau lors de la commande ?', a: 'Oui, vous pouvez sélectionner votre créneau préféré au moment du paiement, selon les disponibilités.' },
        { q: 'Quels sont les jours de livraison ?', a: 'Les livraisons ont lieu du Lundi au Dimanche. Les créneaux disponibles sont visibles lors de la commande.' },
      ]
    },
    {
      id: 'composition',
      title: 'Composition des packs d\'eau',
      icon: <Icons.Package />,
      questions: [
        { q: 'Puis-je choisir les marques dans mon pack ?', a: 'Oui, vous pouvez composer votre pack selon vos préférences en sélectionnant les marques de votre choix.' },
        { q: 'Puis-je mélanger plusieurs marques dans un même pack ?', a: 'Absolument ! Vous pouvez mélanger différentes marques et types de boissons dans une même commande.' },
        { q: 'Dois-je obligatoirement choisir une seule marque ?', a: 'Non, vous êtes libre de composer votre commande comme vous le souhaitez, sans contrainte de marque unique.' },
        { q: 'Le prix change-t-il selon la composition du pack ?', a: 'Le prix est calculé en fonction des produits sélectionnés, chaque produit ayant son propre tarif.' },
        { q: 'Que se passe-t-il si une marque n\'est plus disponible ?', a: 'Si une marque n\'est plus disponible, nous vous contacterons pour vous proposer une alternative ou un remboursement.' },
        { q: 'Puis-je commander même si je ne connais pas toutes les marques ?', a: 'Bien sûr ! Notre catalogue présente toutes les marques avec leurs descriptions pour vous aider à faire votre choix.' }
      ]
    },
    {
      id: 'depot',
      title: 'Dépôt devant la porte',
      icon: <Icons.Door />,
      questions: [
        { q: 'Que signifie "dépôt devant la porte" ?', a: 'C\'est une option qui permet d\'être livré même en votre absence : votre commande est déposée devant votre domicile, à l\'endroit indiqué.' },
        { q: 'Puis-je être livré en cas d\'absence ?', a: 'Oui, avec l\'option dépôt devant la porte, vous pouvez recevoir votre commande même si vous n\'êtes pas présent.' },
        { q: 'Comment activer l\'option dépôt devant la porte ?', a: 'Cette option est sélectionnable au moment du paiement, dans la section "Options de livraison".' },
        { q: 'Cette option est-elle enregistrée dans ma commande ?', a: 'Oui, l\'information est enregistrée directement dans votre commande et communiquée à notre livreur.' }
      ]
    },
    {
      id: 'payment',
      title: 'Commande et paiement',
      icon: <Icons.CreditCard />,
      questions: [
        { q: 'Quels moyens de paiement acceptez-vous ?', a: 'Nous acceptons les cartes bancaires (Visa, Mastercard), PayPal, et virement bancaire.' },
        { q: 'Le paiement en ligne est-il sécurisé ?', a: 'Oui, tous les paiements sont sécurisés via Google Pay, conforme aux normes bancaires les plus strictes.' },
        { q: 'Quand suis-je débité ?', a: 'Vous êtes débité au moment de la confirmation de votre commande.' },
        { q: 'Puis-je modifier ma commande après paiement ?', a: 'Oui, jusqu\'à la veille de la livraison en contactant notre service client.' }
      ]
    },
    {
      id: 'invoice',
      title: 'Facture et confirmation',
      icon: <Icons.Support />,
      questions: [
        { q: 'Vais-je recevoir une facture ?', a: 'Oui, une facture vous est envoyée par email après chaque commande.' },
        { q: 'Comment récupérer ma facture PDF ?', a: 'Vous pouvez télécharger vos factures depuis votre espace client, rubrique "Mes commandes".' },
        { q: 'Envoyez-vous un email de confirmation après commande ?', a: 'Oui, un email de confirmation vous est envoyé immédiatement après validation de votre commande.' },
        { q: 'Que faire si je ne reçois pas l\'email ?', a: 'Vérifiez vos spams, ou contactez notre service client pour obtenir une confirmation.' }
      ]
    },
    {
      id: 'problem',
      title: 'Problème avec une commande',
      icon: <Icons.Support />,
      questions: [
        { q: 'Que faire en cas de problème de livraison ?', a: 'Contactez notre service client par email ou téléphone, nous traiterons votre demande rapidement.' },
        { q: 'Comment contacter le service client ?', a: 'Vous pouvez nous joindre par email à contact.aquaexpress@gmail.com' },
        { q: 'Que faire si une information est incorrecte dans ma commande ?', a: 'Contactez-nous immédiatement, nous pourrons modifier votre commande si la livraison n\'est pas encore programmée.' }
      ]
    }
  ];

  return (
    <div ref={pageRef}>
      {/* ✅ Hero Section avec animation fade-in */}
      <div className={`relative bg-gradient-to-r from-primary to-secondary py-16 transition-all duration-1000 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 font-playfair animate-fade-in-up">
                Questions fréquentes
              </h1>
              <p className="text-lg mb-4 text-gray-200 animate-fade-in-up animation-delay-200">
                Cette page répond aux questions les plus fréquentes concernant la livraison packs d'eau , boissons et laits, les créneaux, 
                la composition des packs, la commande et le paiement.
              </p>
              <p className="text-gray-200 animate-fade-in-up animation-delay-300">
                Si une information n'est pas claire, la page Contact reste accessible.
              </p>
              <Link 
                to="/contact" 
                className="inline-flex items-center gap-2 bg-secondary text-primary px-6 py-3 rounded-full font-semibold mt-6 hover:scale-105 transition duration-300 animate-fade-in-up animation-delay-400"
              >
                Nous contacter <Icons.ChevronRight />
              </Link>
            </div>
            <div className="relative group animate-fade-in-up animation-delay-500">
              <img 
                src="https://images.unsplash.com/photo-1652077859695-de2851a95620?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="Livraison packs eau"
                className="rounded-2xl shadow-2xl w-full h-80 object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute -bottom-4 -left-4 bg-white rounded-xl p-3 shadow-lg animate-pulse">
                <Icons.Map />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section FAQ avec catégories */}
      <div className={`py-20 bg-cream transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}>
        <div className="container-custom">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* ✅ Sidebar navigation avec animation */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-md p-6 sticky top-24 transition-all duration-300 hover:shadow-xl">
                <h2 className="text-xl font-bold mb-4">Catégories</h2>
                <nav className="space-y-2">
                  {faqSections.map((section, index) => (
                    <button
                      key={section.id}
                      onClick={() => {
                        const element = document.getElementById(section.id);
                        if (element) element.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="block w-full text-left px-4 py-2 rounded-lg hover:bg-gray-100 transition-all duration-300 text-sm hover:scale-105 hover:text-secondary"
                      style={{ transitionDelay: `${index * 50}ms` }}
                    >
                      {section.title}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* ✅ Questions/Réponses avec animations */}
            <div className="lg:col-span-3">
              {faqSections.map((section, sectionIdx) => (
                <div 
                  key={section.id} 
                  id={section.id} 
                  className="mb-12 scroll-mt-24 animate-fade-in-up"
                  style={{ animationDelay: `${sectionIdx * 150 + 200}ms` }}
                >
                  <div className="flex items-center gap-4 mb-6 pb-4 border-b-2 border-secondary">
                    <div className="text-secondary transition-transform duration-500 hover:rotate-12">
                      {section.icon}
                    </div>
                    <h2 className="text-2xl font-bold">{section.title}</h2>
                  </div>
                  <div className="space-y-4">
                    {section.questions.map((faq, idx) => {
                      const questionIndex = `${section.id}-${idx}`;
                      const isOpen = openQuestion === questionIndex;
                      return (
                        <div 
                          key={idx} 
                          className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl"
                        >
                          <button
                            onClick={() => toggleQuestion(questionIndex)}
                            className="w-full flex justify-between items-center p-5 text-left hover:bg-gray-50 transition duration-300 group"
                          >
                            <span className="font-semibold text-lg group-hover:text-secondary transition-colors duration-300">
                              {faq.q}
                            </span>
                            <span className={`transform transition duration-300 ${isOpen ? 'rotate-180' : ''} group-hover:scale-110`}>
                              <Icons.ChevronDown />
                            </span>
                          </button>
                          {isOpen && (
                            <div className="px-5 pb-5 pt-0 text-gray-600 border-t animate-fade-in">
                              <p>{faq.a}</p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}

              {/* ✅ Section finale CTA avec animation */}
              <div className="mt-16 bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-center text-white transition-all duration-500 hover:scale-105 hover:shadow-2xl">
                <h3 className="text-2xl font-bold mb-2 animate-fade-in-up">Vous avez trouvé la réponse à votre question ?</h3>
                <p className="mb-6 text-gray-200 animate-fade-in-up animation-delay-200">
                  Cette FAQ dédiée à la livraison packs d'eau vous permet de commander en toute sérénité.
                  Vous pouvez maintenant passer commande en toute simplicité.
                </p>
                <Link 
                  to="/products" 
                  className="inline-flex items-center gap-2 bg-secondary text-primary px-8 py-3 rounded-full font-semibold hover:scale-105 transition duration-300 animate-fade-in-up animation-delay-400 hover:shadow-xl"
                >
                  Commander maintenant <Icons.ChevronRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;